<template>
  <div
    :class="`color--${color}`"
    class="d-flex cursor--pointer"
    @click="$emit('click')"
  >
    <em v-if="icon" class="mt-1 mr-1" :class="icon" />
    <span :class="[`border--${color}`, { 'border-bottom': withBorder }]">
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'CustomLink',
  props: {
    icon: {
      type: String,
      default: () => null,
    },
    text: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: () => 'green',
    },
    withBorder: {
      type: Boolean,
      default: () => true,
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/variables/_colors.scss';

.color--green {
  color: $green_1;
}

.border--green {
  border-bottom-color: $green_1 !important;
}

.color--red {
  color: $red;
}
.border--red {
  border-bottom-color: $red !important;
}

//continue...
</style>
